import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Button, Modal, Popconfirm } from "antd";
import { useForm } from "antd/es/form/Form";
import { useContext, useEffect, useState } from "react";
import { HomeContext } from "../../containers/Home";
import { TTaskData } from "../../types/task";
import CustomForm from "../CustomForm";
import FormButtonSave from "../FormButtonSave";

interface LateTaskModalProps {
	open: boolean;
	setOpen: (open: boolean) => void;
	updateTaskStatus: (task: TTaskData, status: string) => void;
	taskInfo: TTaskData;
}

function LateTaskModalFooter({
	formRef,
	formReset,
	setFormReset,
	handleFormSave,
	handleFormCancel,
}: {
	formRef: any;
	formReset: boolean;
	setFormReset: (reset: boolean) => void;
	handleFormSave: (values: any) => void;
	handleFormCancel: () => void;
}) {
	const [cancelPopover, setCancelPopover] = useState<boolean>(false);

	return (
		<div className="generic-footer">
			<Popconfirm
				icon={<ExclamationCircleOutlined style={{ color: "grey" }} />}
				title={
					<div style={{ maxWidth: "300px", padding: "10px" }}>
						<>You have unsaved changes. Discard them or continue editing?</>
					</div>
				}
				open={cancelPopover}
				placement="topRight"
				cancelButtonProps={{ ghost: true }}
				cancelText="Discard changes"
				onCancel={() => {
					setCancelPopover(false);
					setTimeout(() => {
						handleFormCancel();
					}, 300);
				}}
				okText="Continue editing"
				okType="default"
				onConfirm={() => {
					setCancelPopover(false);
				}}
			>
				<Button
					className="ant-btn-secondary"
					onClick={() => {
						if (formReset) {
							handleFormCancel();
						} else {
							setCancelPopover(true);
						}
					}}
				>
					Cancel
				</Button>
			</Popconfirm>
			<Popconfirm
				icon={<ExclamationCircleOutlined style={{ color: "grey" }} />}
				title={
					<div style={{ maxWidth: "300px", padding: "10px" }}>
						<>You have unsaved changes. Discard them or continue editing?</>
					</div>
				}
				placement="topRight"
			>
				<FormButtonSave
					form={formRef}
					handleFormSave={handleFormSave}
					formReset={formReset}
					setFormReset={setFormReset}
				></FormButtonSave>
			</Popconfirm>
		</div>
	);
}

function LateTaskModal({
	open,
	setOpen,
	updateTaskStatus,
	taskInfo,
}: LateTaskModalProps) {
	const { handleFormUpdating }: any = useContext(HomeContext);

	const [formRef] = useForm();
	const [formReset, setFormReset] = useState<boolean>(true);

	const resetForm = (values: any = null, reset: any = true) => {
		if (formRef) {
			setFormReset(true);
			reset && formRef.resetFields();
			formRef.setFieldsValue(values ? { ...values } : null);
		}
	};

	const handleFormSave = (values: any) => {
		console.log("saving late task", values);
		const newTask = { ...taskInfo, ...values };
		updateTaskStatus(newTask, "Late");
		setOpen(false);
		resetForm();
		handleFormUpdating(false);
	};

	const handleFormCancel = () => {
		console.log("Cancelling late task");
		setOpen(false);
		resetForm();
		handleFormUpdating(false);
	};

	return (
		<Modal
			open={open}
			closable={false}
			width={"40%"}
			title={"Reason for 'Late' task"}
			centered
			destroyOnClose
			footer={
				<LateTaskModalFooter
					formRef={formRef}
					formReset={formReset}
					setFormReset={setFormReset}
					handleFormSave={handleFormSave}
					handleFormCancel={handleFormCancel}
				/>
			}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					flexWrap: "wrap",
				}}
			>
				<CustomForm
					setFormReset={setFormReset}
					formRef={formRef}
					tabKey={"task-blocker"}
				/>
			</div>
		</Modal>
	);
}

export default LateTaskModal;
